export default {
  buttonWrapper: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    backgroundColor: 'hsla(209, 21%, 42%, .3)',

    padding: '0 20px',
    cursor: 'pointer',
    '& + *': {
      marginLeft: '12px',
    },
    '&:hover': {
      backgroundColor: 'hsla(209, 21%, 42%, 1)',
    },
    '&.active': {
      backgroundColor: 'hsla(209, 21%, 42%, 1)',
    },
  },
  count: {
    width: '16px',
    height: '16px',
    display: 'flex',
    position: 'absolute',
    fontSize: '11px',
    background: 'hsl(0, 0%, 100%)',
    alignItems: 'center',
    lineHeight: '100%',
    borderRadius: '50%',
    justifyContent: 'center',
    top: '22px',
    right: '30px',
    border: '1px solid hsla(0, 0%, 0%, 0.5)',
    color: 'hsla(0, 0%, 0%, 0.8)',
  },
}



// WEBPACK FOOTER //
// ./src/Components/Header/HeaderButton/styles.js